import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BankerGroupModalTopupComponent } from '../banker-group-modal-topup/banker-group-modal-topup.component';
import { BankerGroupModalWithdrawComponent } from '../banker-group-modal-withdraw/banker-group-modal-withdraw.component';
import { BankerGroupModalStatementComponent } from '../banker-group-modal-statement/banker-group-modal-statement.component';
import { BankerGroupModalAddAdminComponent } from '../banker-group-modal-add-admin/banker-group-modal-add-admin.component';
import { BankerGroupModalReferralComponent } from '../banker-group-modal-referral/banker-group-modal-referral.component';
import { BankerGroupModalLoanComponent } from '../banker-group-modal-loan/banker-group-modal-loan.component';

@Component({
  selector: 'app-banker-group-detail',
  templateUrl: './banker-group-detail.component.html',
  styleUrls: ['./banker-group-detail.component.scss']
})
export class BankerGroupDetailComponent implements OnInit {

  public data:any = {};
  public admins:any = [];
  public bankers:any = [];
  constructor(private http: HttpService, private activatedRoute: ActivatedRoute, private ngbModal: NgbModal) { 
    this.activatedRoute.params.subscribe(params => {
      if(params['uuid']) {
        this.getDetail(params['uuid']);
      } else {
        this.http.navigate(['/lo', this.http.getStaticSelectedCompany(), 'banker-group-management']);
      }
    });
  }

  ngOnInit(): void {
  }

  async getDetail(uuid: string) {
    this.data = await this.http.post("/admin/banker-group/get", {uuid: uuid});
    let admins:any = await this.http.post("/admin/banker-group/get-admins", {banker_group_uuid: uuid});
    this.admins = admins.data;
    let bankers:any = await this.http.post("/admin/banker-group/get-bankers", {banker_group_uuid: uuid});
    this.bankers = bankers.data;
  }

  bankerTopup() {
    let modal:any = this.ngbModal.open(BankerGroupModalTopupComponent, {size: "md"});
    modal.componentInstance.banker_group_uuid = this.data.uuid;
    modal.componentInstance.closeEvent.subscribe(async (v:any) => {
      if(v) {
        await this.getDetail(this.data.uuid);
      }
      modal.close();
    });
  }

  bankerWithdraw() {
    let modal:any = this.ngbModal.open(BankerGroupModalWithdrawComponent, {size: "md"});
    modal.componentInstance.banker_group_uuid = this.data.uuid;
    modal.componentInstance.closeEvent.subscribe(async (v:any) => {
      if(v) {
        await this.getDetail(this.data.uuid);
      }
      modal.close();
    });
  }

  statement() {
    let modal:any = this.ngbModal.open(BankerGroupModalStatementComponent, {size: "md"});
    console.log(this.data);
    modal.componentInstance.banker_group_uuid = this.data.uuid;
    modal.componentInstance.closeEvent.subscribe(async (v:any) => {
      if(v) {
        await this.getDetail(this.data.uuid);
      }
      modal.close();
    });
  }

  addAdmin() {
    let modal:any = this.ngbModal.open(BankerGroupModalAddAdminComponent, {size: "md"});
    modal.componentInstance.banker_group_uuid = this.data.uuid;
    modal.componentInstance.closeEvent.subscribe(async (v:any) => {
      if(v) {
        await this.getDetail(this.data.uuid);
      }
      modal.close();
    });
  }

  editAdmin(admin: any) {
    let modal:any = this.ngbModal.open(BankerGroupModalAddAdminComponent, {size: "md"});
    modal.componentInstance.banker_group_uuid = this.data.uuid;
    modal.componentInstance.setData = admin;
    modal.componentInstance.closeEvent.subscribe(async (v:any) => {
      if(v) {
        await this.getDetail(this.data.uuid);
      }
      modal.close();
    });
  }

  deleteAdmin(admin: any) {
    console.log(admin);
  }

  viewReferral(banker: any) {
    let modal:any = this.ngbModal.open(BankerGroupModalReferralComponent, {size: "md"});
    modal.componentInstance.player_uuid = banker.uuid;
    modal.componentInstance.closeEvent.subscribe(async (v:any) => {
      modal.close();
    });
  }

  viewActiveLoan(banker: any) {
    let modal:any = this.ngbModal.open(BankerGroupModalLoanComponent, {size: "md"});
    modal.componentInstance.banker_group_uuid = this.data.uuid;
    modal.componentInstance.player_uuid = banker.uuid;
    modal.componentInstance.type = 'active';
    modal.componentInstance.closeEvent.subscribe(async (v:any) => {
      modal.close();
    });
  }

  viewLoan(banker: any) {
    let modal:any = this.ngbModal.open(BankerGroupModalLoanComponent, {size: "md"});
    modal.componentInstance.banker_group_uuid = this.data.uuid;
    modal.componentInstance.player_uuid = banker.uuid;
    modal.componentInstance.type = 'total';
    modal.componentInstance.closeEvent.subscribe(async (v:any) => {
      modal.close();
    });
  }
}
